import React from 'react';
import { View, Pressable, StyleSheet, Platform } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import useResponsiveness from '@/hooks/useResponsiveness';
import Text from '@/components/Typography/Text';

const isWeb = Platform.OS === 'web';

/**
 * Meta line on the left, Terms · Privacy on the right (stacks on XS).
 */
export default function AppDashboardFooterBottomBar({
  metaText,
  termsLabel,
  privacyLabel,
  onNavigate,
}) {
  const { colors } = useTheme();
  const { isXS } = useResponsiveness();

  return (
    <View
      style={[
        styles.bottom,
        { borderTopColor: colors.border_color_secondary },
        isXS && styles.bottomStack,
      ]}
    >
      <Text size="xxs" color="tertiary" style={styles.meta}>
        {metaText}
      </Text>
      <View style={[styles.legalRow, isXS && styles.legalRowEnd]}>
        <Pressable
          onPress={() => onNavigate('/terms-of-service')}
          style={isWeb ? { cursor: 'pointer' } : undefined}
        >
          {({ pressed }) => (
            <Text size="xxs" color="secondary" style={[styles.legalLink, pressed && { opacity: 0.7 }]}>
              {termsLabel}
            </Text>
          )}
        </Pressable>
        <Text size="xxs" color="tertiary" style={styles.dot}>
          ·
        </Text>
        <Pressable
          onPress={() => onNavigate('/privacy-policy')}
          style={isWeb ? { cursor: 'pointer' } : undefined}
        >
          {({ pressed }) => (
            <Text size="xxs" color="secondary" style={[styles.legalLink, pressed && { opacity: 0.7 }]}>
              {privacyLabel}
            </Text>
          )}
        </Pressable>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  bottom: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    paddingTop: 14,
    marginTop: 24,
    borderTopWidth: StyleSheet.hairlineWidth,
  },
  bottomStack: {
    alignItems: 'flex-start',
  },
  meta: {
    flex: 1,
    minWidth: 200,
    letterSpacing: 0.15,
    opacity: 0.88,
    lineHeight: 18,
  },
  legalRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  legalRowEnd: {
    alignSelf: 'flex-end',
  },
  legalLink: {
    letterSpacing: 0.1,
  },
  dot: {
    marginHorizontal: 8,
    opacity: 0.6,
  },
});
